// components/PageHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import './PageHeader.css';

const PageHeader = ({ title, subtitle, breadcrumbs = [] }) => {
    return (
        <section className="page-header">
            <div className="page-header-glow"></div>
            <div className="container">
                <nav className="breadcrumbs" aria-label="Breadcrumb">
                    <Link to="/">Home</Link>
                    {breadcrumbs.map((crumb) => (
                        <React.Fragment key={crumb.label}>
                            <FaChevronRight className="breadcrumb-sep" />
                            {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : <span>{crumb.label}</span>}
                        </React.Fragment>
                    ))}
                </nav>
                <h1 className="page-header-title">{title}</h1>
                {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
            </div>
        </section>
    );
};

export default PageHeader;
